/** App roles derived from public.members (canonical user table). */
export type MemberAppRole = 'user' | 'creator' | 'admin';

/**
 * Prod carries both `is_admin` boolean and `role='admin'` text (REN-125).
 */
export function mapMemberRole(member: {
  is_admin?: boolean | null;
  role?: string | null;
}): MemberAppRole {
  if (member.is_admin === true || member.role === 'admin') return 'admin';
  if (member.role === 'creator') return 'creator';
  return 'user';
}
